import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { OrderSearchTemplate } from 'components/Templates'

const OrderSearch: FC = () => {
  return (
    <Layout headline={'注文検索'} title={'注文検索'}>
      <OrderSearchTemplate />
    </Layout>
  )
}

export default OrderSearch
